
  document.addEventListener("DOMContentLoaded", function () {

        setTimeout(function () {
      const reviewCount = document.querySelector('.main-about-pdp .ruk-rating-snippet-count');
      if (reviewCount) {
        // Extract numeric value
        const countMatch = reviewCount.textContent.match(/\d+/);
        let count = countMatch ? parseInt(countMatch[0], 10) : 0;

        // Dynamic formatting: round down to nearest 100 if >=100, else show exact
        let displayCount;
        if (count >= 100) {
          const magnitude = Math.pow(10, count.toString().length - 1); // nearest 100, 1000, etc.
          displayCount = Math.floor(count / magnitude) * magnitude + '+';
        } else {
          displayCount = `${count}`;
        }

        // Add an ID for targeting
        reviewCount.id = 'custom-review-count';
        reviewCount.style.setProperty('display', 'inline-block', 'important');

        // Update text with link
        reviewCount.innerHTML = `Loved by <a href="https://phyla.com/pages/reviews" style="color: inherit; text-decoration: underline;">1500+ reviewers</a>`;
      }
    }, 500); // delay in ms
    
    // Initialize swipers with a check for Swiper being available
    function initSwipers() {
      if (typeof Swiper !== 'undefined') {
        var swiperCleanser = new Swiper(".swiperThumbSystem", {
          spaceBetween: 10,
          slidesPerView: 10,
          freeMode: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-thumb-next-system",
            prevEl: ".swiper-thumb-prev-system",
          },
          breakpoints: {
            320: {
              slidesPerView: 4,
              spaceBetween: 10,
              direction: "horizontal",
            },
            640: {
              slidesPerView: 5,
              spaceBetween: 10,
              direction: "horizontal",
            },
            768: {
              slidesPerView: 7,
              spaceBetween: 10,
              direction: "horizontal",
            },
            1100: {
              slidesPerView: 9.5,
              spaceBetween: 10,
              direction: "vertical",
            },
          },
        });
        var swiperSystem = new Swiper(".pdpSwiperSystem", {
          spaceBetween: 10,
          direction: "horizontal",
          navigation: {
            nextEl: ".swiper-button-next-pdp",
            prevEl: ".swiper-button-prev-pdp",
          },
          thumbs: {
            swiper: swiperCleanser,
          },
          breakpoints: {
            768: {
              direction: "horizontal",
            },
            1100: {
              direction: "vertical",
            },
          },
        });
      } else {
        // Retry if Swiper not yet loaded
        setTimeout(initSwipers, 100);
      }
    }
    
    // Start initializing swipers
    initSwipers();
});
